import {v4 as uuidv4} from 'uuid';
/**
 * Add an id for referencing each object in navigation
 * to reduce re-rendering in the UI. These id's should
 * not be used for any event logging as they are regenerated
 * each time the DirectNavigation JSON is pulled from HAVR-API
 * and are only client side data.
 * @param navigation
 */
function transformNavigation(navigation) {
    if (!navigation) {
        return null;
    }

    let structures = navigation.structures || null;
    let groups =
        structures === null
            ? navigation.floors || navigation.groups
            : structures.reduce(
                  (accumulator, currentValue) =>
                      accumulator.concat(currentValue.floors || currentValue.groups),
                  []
              );
    let spaces =
        groups === null
            ? navigation.spaces
            : groups.reduce(
                  (accumulator, currentValue) => accumulator.concat(currentValue.spaces),
                  []
              );
    [structures, groups, spaces].forEach((collection) => {
        if (collection !== null) {
            collection.forEach((element) => {
                if (!element.id) {
                    /**
                     * if no id exists for the entity on the server,
                     * generate a client/session only id that can
                     * be used by the client to uniquely identify
                     * these entities for display.
                     */
                    element.id = uuidv4();
                }

                if (element.floorType) {
                    element.groupType = element.floorType;
                } else if (element.type) {
                    element.groupType = element.type;
                }
            });
        }
    });
    let source = null || navigation.source;
    return {
        structures,
        groups,
        spaces,
        source,
    };
}

function sortSpaces(spaces) {
    return spaces;
}

function sortGroups(groups) {
    return groups;
}

function sortStructures(structures) {
    // NYI
    return structures;
}

module.exports = {
    transformNavigation,
    sortSpaces,
    sortGroups,
    sortStructures,
};
